/**
 * Configuración para optimización de imágenes
 * Centraliza la configuración de formatos, tamaños y breakpoints
 * para el componente Image y otros componentes relacionados
 */

export const imageConfig = {
  // Formato de salida preferido para imágenes optimizadas
  'image-output-format': 'avif',

  // Tamaños por defecto (sin sizeMax explícito): evita pedir 50 y 1280 automáticamente
  'default-images': [400, 800],

  // Conjunto completo de tamaños disponibles, usado cuando sizeMax viene explícito
  'extra-images': [50, 400, 800, 1280],

  // Configuración de sizes para diferentes breakpoints
  sizes: {
    mobile: '100vw',
    tablet: '100vw',
    desktop: '800px',
  },

  // Breakpoints para media queries
  breakpoints: {
    tablet: '768px',
    desktop: '1024px',
  },

  // Configuración adicional para futuras extensiones
  // Por ejemplo: metadatos, formatos adicionales, etc.
};
